// extracted by mini-css-extract-plugin
module.exports = {"header":"_3yHW4UrLlCPpHXtEB3kjWJ","title":"_3AFdK0yuIiwdJMxroTDQHe","btn-wide":"_32lihTrvHEVrpn7uxiM_yz","body":"_176kHMuffVYlmZ5I7EO1hm"};